import { Link, useLocation } from "react-router-dom";
// Import the updated types from index.tsx
import { MenuLink, AppSection } from "."; 

// Define props based on the updated MenuLink + onSectionChange
interface HeaderButtonProps extends MenuLink { 
  onSectionChange?: (section: AppSection) => void;
}

function HeaderButton({ 
  name, 
  url, 
  icon: Icon, // Destructure icon 
  visible, 
  action, // Add action 
  onSectionChange // Add onSectionChange 
}: HeaderButtonProps) {
  const location = useLocation();
  const isActive = url ? location.pathname === url : false; // Only active if it's a URL link

  if (!visible) return null;

  const content = (
    <>
      <Icon className="h-5 w-5" />
      {name}
    </>
  );

  // Conditional rendering: Link or Button based on action/url
  if (action && onSectionChange) {
    // Render a button that triggers the action
    return (
      <li>
        <button
          onClick={() => onSectionChange(action)}
          className={`flex items-center gap-1 p-2 rounded hover:bg-muted focus:outline-none focus:ring-1 focus:ring-ring transition-colors text-sm font-medium 
          ${isActive ? "text-primary" : "text-muted-foreground hover:text-foreground"}` // Styling might need adjustment for active state without URL
          }
          data-tooltip-id="header-tooltip"
          data-tooltip-content={name}
        >
          {content}
        </button>
      </li>
    );
  } else if (url) {
    // Render a Link for navigation
    return (
      <li>
        <Link
          to={url}
          className={`flex items-center gap-1 p-2 rounded hover:bg-muted focus:outline-none focus:ring-1 focus:ring-ring transition-colors text-sm font-medium 
            ${isActive ? "text-primary" : "text-muted-foreground hover:text-foreground"}`}
          data-tooltip-id="header-tooltip"
          data-tooltip-content={name}
        >
          {content}
        </Link>
      </li>
    );
  } else {
    // Fallback if neither action nor url is provided (shouldn't happen with current menuLinks)
    return null; 
  }
}

export default HeaderButton; 